/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Plan_History_StatusInputs */

const en_us2_plan_history_status = /** @type {(inputs: Plan_History_StatusInputs) => LocalizedString} */ (i) => {
	if (i?.status === "active") return /** @type {LocalizedString} */ (`Plan put into effect`);
	return /** @type {LocalizedString} */ (`Plan archived`)
	
};

const pt_br2_plan_history_status = /** @type {(inputs: Plan_History_StatusInputs) => LocalizedString} */ (i) => {
	if (i?.status === "active") return /** @type {LocalizedString} */ (`Plano colocado em vigor`);
	return /** @type {LocalizedString} */ (`Plano arquivado`)
	
};

const es_419_plan_history_status = /** @type {(inputs: Plan_History_StatusInputs) => LocalizedString} */ (i) => {
	if (i?.status === "active") return /** @type {LocalizedString} */ (`Plan puesto en vigor`);
	return /** @type {LocalizedString} */ (`Plan archivado`)
	
};

const pt_pt2_plan_history_status = /** @type {(inputs: Plan_History_StatusInputs) => LocalizedString} */ (i) => {
	if (i?.status === "active") return /** @type {LocalizedString} */ (`Plano posto em vigor`);
	return /** @type {LocalizedString} */ (`Plano arquivado`)
	
};

const fr_fr2_plan_history_status = /** @type {(inputs: Plan_History_StatusInputs) => LocalizedString} */ (i) => {
	if (i?.status === "active") return /** @type {LocalizedString} */ (`Programme mis en place`);
	return /** @type {LocalizedString} */ (`Programme archivé`)
	
};

const de_de2_plan_history_status = /** @type {(inputs: Plan_History_StatusInputs) => LocalizedString} */ (i) => {
	if (i?.status === "active") return /** @type {LocalizedString} */ (`Plan aktiviert`);
	return /** @type {LocalizedString} */ (`Plan archiviert`)
	
};

const it_it2_plan_history_status = /** @type {(inputs: Plan_History_StatusInputs) => LocalizedString} */ (i) => {
	if (i?.status === "active") return /** @type {LocalizedString} */ (`Scheda attivata`);
	return /** @type {LocalizedString} */ (`Scheda archiviata`)
	
};

/**
* | status | output |
* | --- | --- |
* | "active" | "Plan put into effect" |
* | * | "Plan archived" |
*
* @param {Plan_History_StatusInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_history_status = /** @type {((inputs: Plan_History_StatusInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_History_StatusInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_history_status(inputs)
	if (locale === "es-419") return es_419_plan_history_status(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_history_status(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_history_status(inputs)
	if (locale === "de-DE") return de_de2_plan_history_status(inputs)
	if (locale === "it-IT") return it_it2_plan_history_status(inputs)
	return en_us2_plan_history_status(inputs)
});
export { plan_history_status as "plan.history_status" }